<template>
  <div :class="['custom-select', {'custom-select_opened': showList, '_error': v && v.$error, 'custom-select_locked': locked }]" v-click-outside="closeOptions">
    <input type="hidden" :name="name" v-model="valueLocal">
    <template v-if="inputSearch">
      <input
        type="text"
        class="custom-select__value"
        :placeholder="placeholder ? placeholder : 'Выберите...'"
        @focus="showList = true"
        v-model="text"
        @keypress="isLetter($event)"
      >
      <span class="custom-select__clear" v-if="text !== ''" @click="text = ''">&times;</span>
    </template>
    <div
      v-else
      :class="['custom-select__value', {'custom-select__value_empty': text === ''}]"
      @click="showListTrigger"
    >
      <template v-if="text === '' && defaultItem">
        <span v-html="defaultItem"></span>
      </template>
      <template v-else-if="text === ''">
        <span v-html="placeholder ? placeholder : 'Выберите...'"></span>
      </template>
      <template v-else>
        <span v-html="text"></span>
      </template>
    </div>
    <svg class="custom-select__arrow" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0 0H4H8L4 8L0 0Z" fill="#292929"/></svg>
    <transition name="slide-fade">
      <ul class="custom-select__list" v-if="showList">
        <li
          v-if="defaultItem"
          :class="[{'_selected': text === '' && defaultItem}]"
          v-html="defaultItem"
          @click="selectOption({
            text: '',
            value: ''
          })"
        />
        <li
          v-for="(item, i) in dataArray"
          :key="i"
          :class="[{'_selected': item.value === valueLocal, 'g-hidden': inputSearch && filter(item.text)}]"
          v-html="item.text"
          @click="selectOption(item)"
          @click.capture="(e) => sendStat(e, 'clickFiltrationYM', `${item.value}` )"
        />
        <li v-if="inputSearch && listEmpty" class="_no-result">Не найдено</li>
      </ul>
    </transition>
  </div>
</template>

<script>
import YMStat from "../tools/ymStat";
import { isLetter } from "../tools/isLetter";
export default {
  name: 'CustomSelect',
  props: {
    dataArray: {
      type: Array,
      default: () => {return []}
    },
    v: {
      type: Object,
      default: undefined,
      //required: true
    },
    placeholder: {
      type: String,
      default: ''
    },
    selectedItem: {
      type: Number,
      default: undefined
    },
    defaultItem: {
      type: String,
      default: ''
    },
    reset: {
      type: Boolean,
      default: false
    },
    value: {
      type: [Number, String],
      default: undefined
    },
    name: {
      type: String,
      default: 'type'
    },
    emitOnInit: {
      type: Boolean,
      default: false
    },
    inputSearch: {
      type: Boolean,
      default: false
    },
    noEmpty: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      text: '',
      valueLocal: undefined,
      showList: false,
      locked: false,
    }
  },
  watch: {
    reset(v) {
      if (v) {
        this.text = '';
        this.valueLocal = '';
      }
    }
  },
  computed: {
    listEmpty() {
      let result = [];
      result = this.dataArray.filter(obj => obj.text.toString().toUpperCase().includes(this.text.toString().toUpperCase()));
      return result.length < 1;
    },
  },
  mounted() {
    if (this.dataArray.length === 1) {
      this.locked = true;
      this.selectOption(this.dataArray[0]);
    } else {
      if (this.selectedItem !== undefined && this.value === undefined) {
        this.selectOption(this.dataArray[this.selectedItem], this.emitOnInit);
      } else if (this.value) {
        const _selectedObject = this.dataArray.find(el => el.value.toString() === this.value);
        if (_selectedObject) {
          this.selectOption(_selectedObject, this.emitOnInit);
        }
      }
    }
  },
  methods: {
    showListTrigger() {
      if (!this.locked) {
        this.showList = !this.showList;
      }
    },
    selectOption(item, emit = true) {
      if (this.noEmpty && item.value === this.valueLocal) {
        return
      }

      if (item.value === this.valueLocal && !this.inputSearch) {
        this.text = '';
        this.valueLocal = undefined;
      } else {
        this.text = item.text;
        this.valueLocal = item.value;
      }

      this.showList = false;
      if (this.v) {
        this.v.$touch();
      }

      if (emit) {
        this.$emit('input', this.valueLocal);
      }
    },
    sendStat(e, param, value){
      YMStat[param](value)
    },
    closeOptions() {
      this.showList = false;
      if (this.inputSearch) {
        this.checkInputValue();
      }
    },
    filter(item) {
      return !item.toString().toUpperCase().includes(this.text.toString().toUpperCase());
    },
    checkInputValue() {
      let val;
      val = this.dataArray.find(obj => {
        return obj.text.toUpperCase() === this.text.toUpperCase()
      });
      if (val) {
        this.selectOption(val);
      } else {
        this.text = '';
        this.valueLocal = undefined;
        this.$emit('input', this.valueLocal);
      }
    },
    isLetter,
  }
}
</script>
